var map = {
	"./_Blue/blue_001.png": "f126",
	"./_Blue/blue_002.png": "9ecb",
	"./_Blue/blue_003.png": "8aab",
	"./_Blue/blue_004.png": "e615",
	"./_Blue/blue_005.png": "285c",
	"./_Blue/blue_006.png": "c52a",
	"./_Blue/blue_007.png": "5f40",
	"./_Blue/blue_008.png": "b067",
	"./_Blue/blue_009.png": "20fb",
	"./_Blue/blue_010.png": "de62",
	"./_Blue/blue_011.png": "dbdc",
	"./_Blue/blue_012.png": "a6d1",
	"./_Blue/blue_013.png": "72b6",
	"./_Blue/blue_014.png": "620a",
	"./_Blue/blue_015.png": "54ca",
	"./_Blue/blue_016.png": "5102",
	"./_Blue/blue_017.png": "9444",
	"./_Blue/blue_018.png": "a0cc",
	"./_Blue/blue_019.png": "07c3",
	"./_Blue/blue_020.png": "72ef",
	"./_Blue/blue_021.png": "7f5f",
	"./_Blue/blue_022.png": "e09a",
	"./_Blue/blue_023.png": "78ec",
	"./_Blue/blue_024.png": "aad0",
	"./_Blue/blue_025.png": "13a0",
	"./_Blue/blue_026.png": "4acb",
	"./_Blue/blue_027.png": "85a2",
	"./_Blue/blue_028.png": "11f1",
	"./_Blue/blue_029.png": "d93c",
	"./_Blue/blue_030.png": "5634",
	"./_Blue/blue_031.png": "805f",
	"./_Blue/blue_032.png": "f621",
	"./_Blue/blue_033.png": "ef16",
	"./_Blue/blue_034.png": "1225",
	"./_Blue/blue_035.png": "5e78",
	"./_Blue/blue_036.png": "c8ba4",
	"./_Blue/blue_037.png": "012b",
	"./_Blue/blue_038.png": "7b8d",
	"./_Blue/blue_039.png": "5b62",
	"./_Blue/blue_040.png": "46d0",
	"./_Blue/blue_041.png": "f3d2",
	"./_Blue/blue_042.png": "4d07",
	"./_Blue/blue_043.png": "099d",
	"./_Blue/blue_044.png": "1c87",
	"./_Blue/blue_045.png": "bf3f",
	"./_Blue/blue_046.png": "8207",
	"./_Blue/blue_047.png": "33fa",
	"./_Blue/blue_048.png": "b2fd",
	"./_Blue/blue_049.png": "b3bd",
	"./_Blue/blue_050.png": "f617",
	"./_Blue/blue_051.png": "125c",
	"./_Blue/blue_052.png": "1865",
	"./_Blue/blue_053.png": "34a0",
	"./_Blue/blue_054.png": "4e4a",
	"./_Blue/blue_055.png": "6086",
	"./_Blue/blue_056.png": "92c8",
	"./_Blue/blue_057.png": "9ed4",
	"./_Blue/blue_058.png": "003b",
	"./_Blue/blue_059.png": "7ebc",
	"./_Blue/blue_060.png": "d8ad",
	"./_Blue/blue_061.png": "7d4c",
	"./_Blue/blue_062.png": "b107",
	"./_Blue/blue_063.png": "b2d78",
	"./_Blue/blue_064.png": "0f96",
	"./_Blue/blue_065.png": "f5ca",
	"./_Blue/blue_066.png": "e7ce",
	"./_Blue/blue_067.png": "ff89",
	"./_Blue/blue_068.png": "9008",
	"./_Blue/blue_069.png": "6a6a",
	"./_Blue/blue_070.png": "fb58",
	"./_Blue/blue_071.png": "a01a",
	"./_Blue/blue_072.png": "80fc",
	"./_Blue/blue_073.png": "5d36",
	"./_Blue/blue_074.png": "9b8b",
	"./_Blue/blue_075.png": "8407",
	"./_Blue/blue_076.png": "de03",
	"./_Blue/blue_077.png": "196e",
	"./_Blue/blue_078.png": "962f",
	"./_Blue/blue_079.png": "357f",
	"./_Blue/blue_080.png": "6814",
	"./_Blue/blue_081.png": "a384",
	"./_Blue/blue_082.png": "71b6",
	"./_Blue/blue_083.png": "4c8b",
	"./_Blue/blue_084.png": "e4e7",
	"./_Blue/blue_085.png": "361c",
	"./_Blue/blue_086.png": "a6c1",
	"./_Blue/blue_087.png": "f9fe",
	"./_Blue/blue_088.png": "5a42",
	"./_Blue/blue_089.png": "5776",
	"./_Blue/blue_090.png": "67fc",
	"./_Blue/blue_091.png": "59f5",
	"./_Blue/blue_092.png": "8d7a",
	"./_Blue/blue_093.png": "ce91",
	"./_Blue/blue_094.png": "df12",
	"./_Blue/blue_095.png": "80fc3",
	"./_Blue/blue_096.png": "9673",
	"./_Blue/blue_097.png": "be9c",
	"./_Blue/blue_098.png": "fa62",
	"./_Blue/blue_099.png": "1149",
	"./_Blue/blue_100.png": "0fb5",
	"./_Blue/blue_101.png": "39ef",
	"./_Blue/blue_102.png": "39ab",
	"./_Blue/blue_103.png": "c96e",
	"./_Blue/blue_104.png": "6b71",
	"./_Blue/blue_105.png": "f68d",
	"./_Blue/blue_106.png": "0e32",
	"./_Blue/blue_107.png": "91de",
	"./_Blue/blue_108.png": "1650",
	"./_Blue/blue_109.png": "9ced",
	"./_Blue/blue_110.png": "e29d",
	"./_Blue/blue_111.png": "7e12",
	"./_Blue/blue_112.png": "a697",
	"./_Blue/blue_113.png": "d22d",
	"./_Blue/blue_114.png": "1e57",
	"./_Blue/blue_115.png": "6854",
	"./_Blue/blue_116.png": "7ab1",
	"./_Blue/blue_117.png": "60e8",
	"./_Blue/blue_118.png": "43a5",
	"./_Blue/blue_119.png": "ce9b",
	"./_Blue/blue_120.png": "9ba6",
	"./_Blue/blue_121.png": "4045",
	"./_Blue/blue_122.png": "02ce",
	"./_Blue/blue_123.png": "5ded",
	"./_Blue/blue_124.png": "d2aa",
	"./_Blue/blue_125.png": "5538",
	"./_Blue/blue_126.png": "3bb0",
	"./_Blue/blue_127.png": "63eb",
	"./_Blue/blue_128.png": "3388",
	"./_Blue/blue_129.png": "4dba",
	"./_Blue/blue_130.png": "163b",
	"./_Blue/blue_131.png": "a959",
	"./_Blue/blue_132.png": "f6cf3",
	"./_Blue/blue_133.png": "39d7",
	"./_Blue/blue_134.png": "2909",
	"./_Blue/blue_135.png": "f0b5",
	"./_Blue/blue_136.png": "4b3d",
	"./_Blue/blue_137.png": "225a",
	"./_Blue/blue_138.png": "585c",
	"./_Blue/blue_139.png": "d1c6",
	"./_Blue/blue_140.png": "952f",
	"./_Blue/blue_141.png": "3f07",
	"./_Blue/blue_142.png": "9fe8",
	"./_Blue/blue_143.png": "52a7",
	"./_Blue/blue_144.png": "2057",
	"./_Blue/blue_145.png": "4516",
	"./_Blue/blue_146.png": "0413",
	"./_Blue/blue_147.png": "5204",
	"./_Blue/blue_148.png": "7753",
	"./_Blue/blue_149.png": "27e2",
	"./_Blue/blue_150.png": "b352",
	"./_Blue/blue_151.png": "7198",
	"./_Blue/blue_152.png": "cf45",
	"./_Blue/blue_153.png": "59dc",
	"./_Blue/blue_154.png": "62fd",
	"./_Blue/blue_155.png": "c4c4",
	"./_Blue/blue_156.png": "392a",
	"./_Blue/blue_157.png": "cc16",
	"./_Blue/blue_158.png": "2995",
	"./_Blue/blue_159.png": "0f2b",
	"./_Blue/blue_160.png": "9a53",
	"./_Blue/blue_161.png": "a496",
	"./_Blue/blue_162.png": "fae7",
	"./_Blue/blue_163.png": "b359",
	"./_Blue/blue_164.png": "bf12",
	"./_Blue/blue_165.png": "5ae8",
	"./_Blue/blue_166.png": "348b",
	"./_Blue/blue_167.png": "beb7",
	"./_Blue/blue_168.png": "df71",
	"./_Blue/blue_169.png": "8a22",
	"./_Blue/blue_170.png": "0d93",
	"./_Blue/blue_171.png": "c1ea",
	"./_Blue/blue_172.png": "5b20",
	"./_Blue/blue_173.png": "0608",
	"./_Blue/blue_174.png": "1a5b",
	"./_Blue/blue_175.png": "9d0c",
	"./_Blue/blue_176.png": "7f84",
	"./_Blue/blue_177.png": "50f8",
	"./_Blue/blue_178.png": "a824",
	"./_Blue/blue_179.png": "60e1",
	"./_Green/green_001.png": "1cbd",
	"./_Green/green_002.png": "1916",
	"./_Green/green_003.png": "5dce",
	"./_Green/green_004.png": "a7cc",
	"./_Green/green_005.png": "4af4",
	"./_Green/green_006.png": "f0b3",
	"./_Green/green_007.png": "0098",
	"./_Green/green_008.png": "5bc4",
	"./_Green/green_009.png": "4eef",
	"./_Green/green_010.png": "f0e8",
	"./_Green/green_011.png": "004a",
	"./_Green/green_012.png": "5423",
	"./_Green/green_013.png": "3aed",
	"./_Green/green_014.png": "e122",
	"./_Green/green_015.png": "5bd2",
	"./_Green/green_016.png": "63ea",
	"./_Green/green_017.png": "b063",
	"./_Green/green_018.png": "242a",
	"./_Green/green_019.png": "9833",
	"./_Green/green_020.png": "71d2",
	"./_Green/green_021.png": "d1e9",
	"./_Green/green_022.png": "a407",
	"./_Green/green_023.png": "3b28",
	"./_Green/green_024.png": "16c9",
	"./_Green/green_025.png": "dcc2",
	"./_Green/green_026.png": "37b6",
	"./_Green/green_027.png": "8519",
	"./_Green/green_028.png": "50e9",
	"./_Green/green_029.png": "d34e",
	"./_Green/green_030.png": "21b3",
	"./_Green/green_031.png": "4dde",
	"./_Green/green_032.png": "03d6",
	"./_Green/green_033.png": "a93e",
	"./_Green/green_034.png": "ca09",
	"./_Green/green_035.png": "0dda",
	"./_Green/green_036.png": "e85e",
	"./_Green/green_037.png": "d88b",
	"./_Green/green_038.png": "136e",
	"./_Green/green_039.png": "79c9",
	"./_Green/green_040.png": "161e",
	"./_Green/green_041.png": "f083",
	"./_Green/green_042.png": "4729",
	"./_Green/green_043.png": "4056",
	"./_Green/green_044.png": "ee65",
	"./_Green/green_045.png": "db67",
	"./_Green/green_046.png": "f906",
	"./_Green/green_047.png": "a6fb",
	"./_Green/green_048.png": "5ad8",
	"./_Green/green_049.png": "e989",
	"./_Green/green_050.png": "cbdf",
	"./_Green/green_051.png": "2508",
	"./_Green/green_052.png": "8161",
	"./_Green/green_053.png": "80f5",
	"./_Green/green_054.png": "37af",
	"./_Green/green_055.png": "c6e7",
	"./_Green/green_056.png": "4e1f",
	"./_Green/green_057.png": "991e",
	"./_Green/green_058.png": "94da",
	"./_Green/green_059.png": "9f6e",
	"./_Green/green_060.png": "f8f5e",
	"./_Green/green_061.png": "8431",
	"./_Green/green_062.png": "09cd",
	"./_Green/green_063.png": "6c06",
	"./_Green/green_064.png": "32d3",
	"./_Green/green_065.png": "581e",
	"./_Green/green_066.png": "51c6",
	"./_Green/green_067.png": "a985",
	"./_Green/green_068.png": "d9bf",
	"./_Green/green_069.png": "c23c",
	"./_Green/green_070.png": "0955",
	"./_Green/green_071.png": "0113",
	"./_Green/green_072.png": "8aed",
	"./_Green/green_073.png": "c597",
	"./_Green/green_074.png": "3f1f",
	"./_Green/green_075.png": "e61e",
	"./_Green/green_076.png": "bc52",
	"./_Green/green_077.png": "850c",
	"./_Green/green_078.png": "ba06",
	"./_Green/green_079.png": "357b",
	"./_Green/green_080.png": "9f63",
	"./_Green/green_081.png": "6ddb",
	"./_Green/green_082.png": "9d40",
	"./_Green/green_083.png": "3c12",
	"./_Green/green_084.png": "9e99",
	"./_Green/green_085.png": "a375",
	"./_Green/green_086.png": "76bb",
	"./_Green/green_087.png": "3bfa",
	"./_Green/green_088.png": "e3da",
	"./_Green/green_089.png": "b846",
	"./_Green/green_090.png": "b36d",
	"./_Green/green_091.png": "37e3",
	"./_Green/green_092.png": "5e11",
	"./_Green/green_093.png": "a830",
	"./_Green/green_094.png": "38cd",
	"./_Green/green_095.png": "8774",
	"./_Green/green_096.png": "873c",
	"./_Green/green_097.png": "e133",
	"./_Green/green_098.png": "1d0c",
	"./_Green/green_099.png": "5e71",
	"./_Green/green_100.png": "9d49",
	"./_Green/green_101.png": "9fe9",
	"./_Green/green_102.png": "8da6",
	"./_Green/green_103.png": "a3a0",
	"./_Green/green_104.png": "fe3b",
	"./_Green/green_105.png": "fd33",
	"./_Green/green_106.png": "8fa7",
	"./_Green/green_107.png": "9107",
	"./_Green/green_108.png": "d7ee",
	"./_Green/green_109.png": "9e27",
	"./_Green/green_110.png": "7c3a",
	"./_Green/green_111.png": "c7ce",
	"./_Green/green_112.png": "0c6e",
	"./_Green/green_113.png": "b3d4",
	"./_Green/green_114.png": "7a79",
	"./_Green/green_115.png": "81f4",
	"./_Green/green_116.png": "1f8a",
	"./_Green/green_117.png": "cc30",
	"./_Green/green_118.png": "55f2",
	"./_Green/green_119.png": "9259",
	"./_Green/green_120.png": "d5a4",
	"./_Green/green_121.png": "05cd",
	"./_Green/green_122.png": "a56e",
	"./_Green/green_123.png": "53ae",
	"./_Green/green_124.png": "28a3",
	"./_Green/green_125.png": "2760",
	"./_Green/green_126.png": "79a5",
	"./_Green/green_127.png": "a28e",
	"./_Green/green_128.png": "b3d0",
	"./_Green/green_129.png": "e7eb",
	"./_Green/green_130.png": "f846",
	"./_Green/green_131.png": "daaa",
	"./_Green/green_132.png": "8ffb",
	"./_Green/green_133.png": "ee25",
	"./_Green/green_134.png": "7dc7",
	"./_Green/green_135.png": "3a9be",
	"./_Green/green_136.png": "add5",
	"./_Green/green_137.png": "3d26",
	"./_Green/green_138.png": "2861",
	"./_Green/green_139.png": "532d",
	"./_Green/green_140.png": "7b7b",
	"./_Green/green_141.png": "42de",
	"./_Green/green_142.png": "a5cb",
	"./_Green/green_143.png": "b5f2",
	"./_Green/green_144.png": "62ee",
	"./_Green/green_145.png": "bc5c",
	"./_Grey/grey_001.png": "684c",
	"./_Grey/grey_002.png": "ea62",
	"./_Grey/grey_003.png": "f41d",
	"./_Grey/grey_004.png": "510e",
	"./_Grey/grey_005.png": "1e59",
	"./_Grey/grey_006.png": "110b",
	"./_Grey/grey_007.png": "b772",
	"./_Grey/grey_008.png": "aed1",
	"./_Grey/grey_009.png": "32ca",
	"./_Grey/grey_010.png": "2ce9",
	"./_Grey/grey_011.png": "b999",
	"./_Grey/grey_012.png": "1b86",
	"./_Grey/grey_013.png": "b850",
	"./_Grey/grey_014.png": "8cf8",
	"./_Grey/grey_015.png": "e712",
	"./_Grey/grey_016.png": "d93d",
	"./_Grey/grey_017.png": "b740",
	"./_Grey/grey_018.png": "1905",
	"./_Grey/grey_019.png": "9b16",
	"./_Grey/grey_020.png": "20ff",
	"./_Grey/grey_021.png": "5fa7",
	"./_Grey/grey_022.png": "d882",
	"./_Grey/grey_023.png": "05fe",
	"./_Grey/grey_024.png": "bff5",
	"./_Grey/grey_025.png": "548e",
	"./_Grey/grey_026.png": "328b",
	"./_Grey/grey_027.png": "327a",
	"./_Grey/grey_028.png": "8fe7",
	"./_Grey/grey_029.png": "2de3",
	"./_Grey/grey_030.png": "7a90",
	"./_Grey/grey_031.png": "87d1",
	"./_Grey/grey_032.png": "4c2e",
	"./_Grey/grey_033.png": "bf52",
	"./_Grey/grey_034.png": "66ca",
	"./_Grey/grey_035.png": "e653",
	"./_Grey/grey_036.png": "86ce",
	"./_Grey/grey_037.png": "3310",
	"./_Grey/grey_038.png": "4881",
	"./_Grey/grey_039.png": "cdd0",
	"./_Grey/grey_040.png": "b52c",
	"./_Grey/grey_041.png": "a3cd",
	"./_Grey/grey_042.png": "3ca4",
	"./_Grey/grey_043.png": "78df",
	"./_Grey/grey_044.png": "6513",
	"./_Grey/grey_045.png": "5d31",
	"./_Grey/grey_046.png": "ed95",
	"./_Grey/grey_047.png": "e740",
	"./_Grey/grey_048.png": "e6ac",
	"./_Grey/grey_049.png": "b1c6",
	"./_Grey/grey_050.png": "5198",
	"./_Grey/grey_051.png": "22e9",
	"./_Grey/grey_052.png": "deb6",
	"./_Grey/grey_053.png": "14ab",
	"./_Grey/grey_054.png": "9e7c",
	"./_Grey/grey_055.png": "8c46",
	"./_Grey/grey_056.png": "6397",
	"./_Grey/grey_057.png": "282b",
	"./_Grey/rename": "1728",
	"./_Orange/orange_001.png": "a802",
	"./_Orange/orange_002.png": "b539",
	"./_Orange/orange_003.png": "0f89",
	"./_Orange/orange_004.png": "281c",
	"./_Orange/orange_005.png": "6759",
	"./_Orange/orange_006.png": "567e",
	"./_Orange/orange_007.png": "55f0",
	"./_Orange/orange_008.png": "8cb2",
	"./_Orange/orange_009.png": "e926",
	"./_Orange/orange_010.png": "83c0",
	"./_Orange/orange_011.png": "4dcb",
	"./_Orange/orange_012.png": "cd4e",
	"./_Orange/orange_013.png": "b37e",
	"./_Orange/orange_014.png": "4875",
	"./_Orange/orange_015.png": "634a",
	"./_Orange/orange_016.png": "e84b",
	"./_Orange/orange_017.png": "b0a1",
	"./_Orange/orange_018.png": "5f23",
	"./_Orange/orange_019.png": "b032",
	"./_Orange/orange_020.png": "657f",
	"./_Orange/orange_021.png": "4bf8",
	"./_Orange/orange_022.png": "73ec",
	"./_Orange/orange_023.png": "20ce",
	"./_Orange/orange_024.png": "0fa0",
	"./_Orange/orange_025.png": "261c",
	"./_Orange/orange_026.png": "391d",
	"./_Orange/orange_027.png": "cb12",
	"./_Orange/orange_028.png": "398b",
	"./_Orange/orange_029.png": "085d",
	"./_Orange/orange_030.png": "b07a",
	"./_Orange/orange_031.png": "59d6",
	"./_Orange/orange_032.png": "d8c8",
	"./_Orange/orange_033.png": "87a3",
	"./_Orange/orange_034.png": "59ae",
	"./_Orange/orange_035.png": "a552",
	"./_Orange/orange_036.png": "9016",
	"./_Orange/orange_037.png": "aa38",
	"./_Orange/orange_038.png": "f927",
	"./_Orange/orange_039.png": "897d",
	"./_Orange/orange_040.png": "d905e",
	"./_Orange/orange_041.png": "9884",
	"./_Orange/orange_042.png": "d0e0",
	"./_Orange/orange_043.png": "6076",
	"./_Orange/orange_044.png": "4338",
	"./_Orange/orange_045.png": "32ef",
	"./_Orange/orange_046.png": "85fc",
	"./_Orange/orange_047.png": "4406",
	"./_Orange/orange_048.png": "e58c",
	"./_Orange/orange_049.png": "5f50",
	"./_Orange/orange_050.png": "5122",
	"./_Orange/orange_051.png": "865e",
	"./_Orange/orange_052.png": "761c",
	"./_Orange/orange_053.png": "bc56",
	"./_Orange/orange_054.png": "a2ec",
	"./_Orange/orange_055.png": "05da",
	"./_Orange/orange_056.png": "64b5",
	"./_Orange/orange_057.png": "e395",
	"./_Orange/orange_058.png": "e5b2",
	"./_Orange/orange_059.png": "57d8",
	"./_Orange/orange_060.png": "f147",
	"./_Orange/orange_061.png": "eab5",
	"./_Orange/orange_062.png": "bd58",
	"./_Orange/orange_063.png": "df60",
	"./_Orange/orange_064.png": "6a20",
	"./_Orange/orange_065.png": "9fac",
	"./_Orange/orange_066.png": "856c",
	"./_Orange/orange_067.png": "c429",
	"./_Orange/orange_068.png": "ea9e",
	"./_Orange/orange_069.png": "d134",
	"./_Orange/orange_070.png": "2484",
	"./_Orange/orange_071.png": "93a0",
	"./_Orange/orange_072.png": "9d05",
	"./_Orange/orange_073.png": "9f27",
	"./_Orange/orange_074.png": "9ba9",
	"./_Orange/orange_075.png": "a2a8",
	"./_Orange/orange_076.png": "95f2",
	"./_Orange/orange_077.png": "7e10",
	"./_Orange/orange_078.png": "3f9a",
	"./_Orange/orange_079.png": "2282",
	"./_Orange/orange_080.png": "571c",
	"./_Orange/orange_081.png": "fdc6",
	"./_Orange/orange_082.png": "a3d9",
	"./_Orange/orange_083.png": "8e59",
	"./_Orange/orange_084.png": "007b",
	"./_Orange/orange_085.png": "abdd",
	"./_Orange/orange_086.png": "9f7c",
	"./_Orange/orange_087.png": "0246",
	"./_Orange/orange_088.png": "8971",
	"./_Orange/orange_089.png": "f363",
	"./_Orange/orange_090.png": "18d1",
	"./_Orange/orange_091.png": "8c8d",
	"./_Orange/orange_092.png": "c8ca",
	"./_Orange/orange_093.png": "6339",
	"./_Orange/orange_094.png": "4a75e",
	"./_Orange/orange_095.png": "911f",
	"./_Orange/orange_096.png": "eee1",
	"./_Orange/orange_097.png": "d353",
	"./_Orange/orange_098.png": "1056",
	"./_Orange/orange_099.png": "eb06",
	"./_Orange/orange_100.png": "fd34",
	"./_Orange/orange_101.png": "e8e0",
	"./_Orange/orange_102.png": "2730",
	"./_Orange/orange_103.png": "8c8c",
	"./_Orange/orange_104.png": "f5d1",
	"./_Orange/orange_105.png": "3240",
	"./_Orange/orange_106.png": "bbe3",
	"./_Orange/orange_107.png": "b1c4",
	"./_Orange/orange_108.png": "1538",
	"./_Orange/orange_109.png": "3f91",
	"./_Orange/orange_110.png": "0de0",
	"./_Orange/orange_111.png": "51f0",
	"./_Orange/orange_112.png": "078e",
	"./_Orange/orange_113.png": "3b53",
	"./_Orange/orange_114.png": "d632",
	"./_Orange/orange_115.png": "5d4f",
	"./_Orange/orange_116.png": "ac7a",
	"./_Orange/orange_117.png": "0cef",
	"./_Orange/orange_118.png": "a326",
	"./_Orange/orange_119.png": "3390",
	"./_Orange/orange_120.png": "1676",
	"./_Orange/orange_121.png": "8947",
	"./_Orange/orange_122.png": "811d",
	"./_Orange/orange_123.png": "5a43",
	"./_Orange/orange_124.png": "4cbc",
	"./_Orange/orange_125.png": "baf2",
	"./_Orange/orange_126.png": "8495",
	"./_Orange/orange_127.png": "2826",
	"./_Orange/orange_128.png": "d8c7",
	"./_Orange/orange_129.png": "d36f",
	"./_Orange/orange_130.png": "7522",
	"./_Orange/orange_131.png": "25e7",
	"./_Orange/orange_132.png": "eca6",
	"./_Orange/orange_133.png": "ebc2",
	"./_Orange/orange_134.png": "ba33",
	"./_Orange/orange_135.png": "ba4c",
	"./_Orange/rename": "c3d6",
	"./_Purple/rename": "0ba0",
	"./_Purple/violet_001.png": "16d0",
	"./_Purple/violet_002.png": "f603",
	"./_Purple/violet_003.png": "f31a",
	"./_Purple/violet_004.png": "cb37",
	"./_Purple/violet_005.png": "af39",
	"./_Purple/violet_006.png": "c61f",
	"./_Purple/violet_007.png": "cc0a",
	"./_Purple/violet_008.png": "0b6e",
	"./_Purple/violet_009.png": "959d",
	"./_Purple/violet_010.png": "dca7",
	"./_Purple/violet_011.png": "2012",
	"./_Purple/violet_012.png": "2393",
	"./_Purple/violet_013.png": "f3bd",
	"./_Purple/violet_014.png": "b228",
	"./_Purple/violet_015.png": "c153",
	"./_Purple/violet_016.png": "78de",
	"./_Purple/violet_017.png": "3dea",
	"./_Purple/violet_018.png": "aa4d",
	"./_Purple/violet_019.png": "1657",
	"./_Purple/violet_020.png": "67ef",
	"./_Purple/violet_021.png": "b32b",
	"./_Purple/violet_022.png": "2799",
	"./_Purple/violet_023.png": "57c5",
	"./_Purple/violet_024.png": "e3c4",
	"./_Purple/violet_025.png": "67b5",
	"./_Purple/violet_026.png": "a1d8",
	"./_Purple/violet_027.png": "3509",
	"./_Purple/violet_028.png": "6b26",
	"./_Purple/violet_029.png": "75c7",
	"./_Purple/violet_030.png": "7d52",
	"./_Purple/violet_031.png": "7640",
	"./_Purple/violet_032.png": "afba",
	"./_Purple/violet_033.png": "fce1",
	"./_Purple/violet_034.png": "38bb",
	"./_Purple/violet_035.png": "0ee9",
	"./_Purple/violet_036.png": "c04f",
	"./_Purple/violet_037.png": "3bb6",
	"./_Purple/violet_038.png": "6d82",
	"./_Purple/violet_039.png": "7a53",
	"./_Purple/violet_040.png": "63e5",
	"./_Purple/violet_041.png": "851e",
	"./_Purple/violet_042.png": "8b28",
	"./_Purple/violet_043.png": "7f8d",
	"./_Purple/violet_044.png": "8568",
	"./_Purple/violet_045.png": "3901",
	"./_Purple/violet_046.png": "0fad",
	"./_Purple/violet_047.png": "0d52",
	"./_Purple/violet_048.png": "a207",
	"./_Purple/violet_049.png": "3dca",
	"./_Purple/violet_050.png": "a8e7",
	"./_Purple/violet_051.png": "e5a8",
	"./_Purple/violet_052.png": "125a",
	"./_Purple/violet_053.png": "2397",
	"./_Purple/violet_054.png": "5748",
	"./_Purple/violet_055.png": "3646",
	"./_Purple/violet_056.png": "f9f5",
	"./_Purple/violet_057.png": "a0e4",
	"./_Purple/violet_058.png": "6610",
	"./_Purple/violet_059.png": "f389",
	"./_Purple/violet_060.png": "9712",
	"./_Purple/violet_061.png": "9993",
	"./_Purple/violet_062.png": "6784",
	"./_Purple/violet_063.png": "58c0",
	"./_Purple/violet_064.png": "cee5",
	"./_Purple/violet_065.png": "28a5",
	"./_Purple/violet_066.png": "abd6",
	"./_Purple/violet_067.png": "dca4",
	"./_Purple/violet_068.png": "7177",
	"./_Purple/violet_069.png": "e31c",
	"./_Purple/violet_070.png": "5e88",
	"./_Purple/violet_071.png": "a11e",
	"./_Purple/violet_072.png": "a67a",
	"./_Purple/violet_073.png": "20da",
	"./_Purple/violet_074.png": "004f",
	"./_Purple/violet_075.png": "dc87",
	"./_Purple/violet_076.png": "b6aa",
	"./_Purple/violet_077.png": "6149",
	"./_Purple/violet_078.png": "0a26",
	"./_Purple/violet_079.png": "6795",
	"./_Purple/violet_080.png": "c164",
	"./_Purple/violet_081.png": "8b6f",
	"./_Purple/violet_082.png": "b1ac",
	"./_Purple/violet_083.png": "91a7",
	"./_Purple/violet_084.png": "e664",
	"./_Purple/violet_085.png": "34c2",
	"./_Purple/violet_086.png": "f9dd",
	"./_Purple/violet_087.png": "1b02",
	"./_Purple/violet_088.png": "e835",
	"./_Purple/violet_089.png": "e9c7",
	"./_Purple/violet_090.png": "f319",
	"./_Purple/violet_091.png": "07bc",
	"./_Purple/violet_092.png": "9b9d",
	"./_Purple/violet_093.png": "2244",
	"./_Purple/violet_094.png": "9474",
	"./_Purple/violet_095.png": "975a",
	"./_Purple/violet_096.png": "f4ce",
	"./_Purple/violet_097.png": "a553",
	"./_Purple/violet_098.png": "e951",
	"./_Purple/violet_099.png": "9487",
	"./_Purple/violet_100.png": "bcff",
	"./_Purple/violet_101.png": "2619",
	"./_Purple/violet_102.png": "b451",
	"./_Purple/violet_103.png": "a80e",
	"./_Purple/violet_104.png": "f919",
	"./_Purple/violet_105.png": "7c90",
	"./_Purple/violet_106.png": "a673",
	"./_Purple/violet_107.png": "b357",
	"./_Purple/violet_108.png": "03e9",
	"./_Purple/violet_109.png": "8cbb",
	"./_Purple/violet_110.png": "6497",
	"./_Purple/violet_111.png": "5213",
	"./_Purple/violet_112.png": "3a5c",
	"./_Purple/violet_113.png": "e32b",
	"./_Purple/violet_114.png": "dc38",
	"./_Purple/violet_115.png": "f7f1",
	"./_Purple/violet_116.png": "60b1",
	"./_Purple/violet_117.png": "160e",
	"./_Purple/violet_118.png": "b005",
	"./_Purple/violet_119.png": "6f82",
	"./_Purple/violet_120.png": "6de9",
	"./_Purple/violet_121.png": "f006",
	"./_Purple/violet_122.png": "dd36",
	"./_Purple/violet_123.png": "4e98",
	"./_Purple/violet_124.png": "341b",
	"./_Purple/violet_125.png": "b996",
	"./_Purple/violet_126.png": "7c77",
	"./_Purple/violet_127.png": "a58f",
	"./_Purple/violet_128.png": "e54b",
	"./_Purple/violet_129.png": "1ae4",
	"./_Purple/violet_130.png": "b51b",
	"./_Purple/violet_131.png": "abcd",
	"./_Purple/violet_132.png": "336f",
	"./_Purple/violet_133.png": "6d20",
	"./_Purple/violet_134.png": "7efc",
	"./_Purple/violet_135.png": "9a12",
	"./_Purple/violet_136.png": "d581",
	"./_Purple/violet_137.png": "9e34",
	"./_Purple/violet_138.png": "30ee",
	"./_Purple/violet_139.png": "458b",
	"./_Purple/violet_140.png": "71dd",
	"./_Purple/violet_141.png": "cb5e",
	"./_Purple/violet_142.png": "986c",
	"./_Purple/violet_143.png": "1d67",
	"./_Purple/violet_144.png": "053e",
	"./_Purple/violet_145.png": "feae",
	"./_Purple/violet_146.png": "52ae",
	"./_Red/red_001.png": "ad79",
	"./_Red/red_002.png": "2def",
	"./_Red/red_003.png": "3234",
	"./_Red/red_004.png": "28fb",
	"./_Red/red_005.png": "b098",
	"./_Red/red_006.png": "b7d7",
	"./_Red/red_007.png": "17fd",
	"./_Red/red_008.png": "462e",
	"./_Red/red_009.png": "21b34",
	"./_Red/red_010.png": "0389",
	"./_Red/red_011.png": "051b",
	"./_Red/red_012.png": "d571",
	"./_Red/red_013.png": "5e3a",
	"./_Red/red_014.png": "50d1",
	"./_Red/red_015.png": "fb6c",
	"./_Red/red_016.png": "e3fe",
	"./_Red/red_017.png": "3a92",
	"./_Red/red_018.png": "7799",
	"./_Red/red_019.png": "2c16",
	"./_Red/red_020.png": "7903",
	"./_Red/red_021.png": "869a",
	"./_Red/red_022.png": "d954",
	"./_Red/red_023.png": "f7b2",
	"./_Red/red_024.png": "34e5",
	"./_Red/red_025.png": "78b8",
	"./_Red/red_026.png": "af70",
	"./_Red/red_027.png": "18ca",
	"./_Red/red_028.png": "c14a",
	"./_Red/red_029.png": "4c84",
	"./_Red/red_030.png": "a2a1",
	"./_Red/red_031.png": "a659",
	"./_Red/red_032.png": "fb5c",
	"./_Red/red_033.png": "8a94",
	"./_Red/red_034.png": "1f42",
	"./_Red/red_035.png": "e9c2",
	"./_Red/red_036.png": "36c2",
	"./_Red/red_037.png": "e4c2",
	"./_Red/red_038.png": "3098",
	"./_Red/red_039.png": "4f36",
	"./_Red/red_040.png": "f951",
	"./_Red/red_041.png": "09b9",
	"./_Red/red_042.png": "ce9c",
	"./_Red/red_043.png": "b35d",
	"./_Red/red_044.png": "007f",
	"./_Red/red_045.png": "38dc",
	"./_Red/red_046.png": "b1dd",
	"./_Red/red_047.png": "2803",
	"./_Red/red_048.png": "3cb9",
	"./_Red/red_049.png": "3f55",
	"./_Red/red_050.png": "2068",
	"./_Red/red_051.png": "b0a2",
	"./_Red/red_052.png": "96d6",
	"./_Red/red_053.png": "ed1b",
	"./_Red/red_054.png": "6c84",
	"./_Red/red_055.png": "5f02",
	"./_Red/red_056.png": "06e6",
	"./_Red/red_057.png": "e5a3",
	"./_Red/red_058.png": "6b41",
	"./_Red/red_059.png": "dcbb3",
	"./_Red/red_060.png": "8a53",
	"./_Red/red_061.png": "27f0",
	"./_Red/red_062.png": "8ddf",
	"./_Red/red_063.png": "91dc",
	"./_Red/red_064.png": "ece5",
	"./_Red/red_065.png": "191c",
	"./_Red/red_066.png": "5261",
	"./_Red/red_067.png": "12c6",
	"./_Red/red_068.png": "2d3d",
	"./_Red/red_069.png": "33faa",
	"./_Red/red_070.png": "7e8b",
	"./_Red/red_071.png": "683e",
	"./_Red/red_072.png": "aee5",
	"./_Red/red_073.png": "b3e4",
	"./_Red/red_074.png": "d1be8",
	"./_Red/red_075.png": "5462",
	"./_Red/red_076.png": "cb99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d8f";